import type { ButtonHTMLAttributes, ReactNode } from 'react'

type ButtonVariant = 'gradient' | 'outline' | 'solid'
type ButtonSize = 'sm' | 'md' | 'lg'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  children: ReactNode
}

const variantClasses: Record<ButtonVariant, string> = {
  gradient:
    'gradient-cta text-on-primary-container hover:scale-105 active:scale-95 shadow-xl shadow-primary/10',
  outline: 'border border-outline-variant/40 hover:border-primary/60 text-on-surface',
  solid:
    'bg-surface-container-highest text-on-surface border border-outline-variant/30 hover:bg-surface-bright',
}

const sizeClasses: Record<ButtonSize, string> = {
  sm: 'px-6 py-2 text-label-md',
  md: 'px-7 py-3.5 sm:px-8 sm:py-4 md:px-10 md:py-5 text-label-lg',
  lg: 'px-8 py-4 sm:px-10 sm:py-5 md:px-12 md:py-6 text-body-lg',
}

export default function Button({
  variant = 'gradient',
  size = 'md',
  children,
  className = '',
  ...props
}: ButtonProps) {
  return (
    <button
      className={`font-bold tracking-widest uppercase transition-all duration-300 cursor-pointer ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}
